// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"d9c78c6e","462":"008a1610","693":"13aedd12"}[chunkId] + ".chunk.js";
};